import { useEffect, useState } from 'react';

export function ProductGallery({ alt, images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = images.length;

  const showImage = (index) => {
    setCurrentIndex((index + totalImages) % totalImages);
  };

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        setCurrentIndex((index) => (index - 1 + totalImages) % totalImages);
      }
      if (event.key === 'ArrowRight') {
        setCurrentIndex((index) => (index + 1) % totalImages);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [totalImages]);

  return (
    <div className="product-gallery">
      <div className="main-image">
        <img
          src={images[currentIndex]}
          alt={alt}
          decoding="async"
          fetchPriority={currentIndex === 0 ? 'high' : 'auto'}
          loading={currentIndex === 0 ? 'eager' : 'lazy'}
        />
        <div className="image-counter">{currentIndex + 1}/{totalImages}</div>
        <button
          aria-label="Previous image"
          className="gallery-nav prev"
          onClick={() => showImage(currentIndex - 1)}
          type="button"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <button
          aria-label="Next image"
          className="gallery-nav next"
          onClick={() => showImage(currentIndex + 1)}
          type="button"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" /></svg>
        </button>
      </div>
      <div className="thumbnail-gallery">
        {images.map((image, index) => (
          <button
            aria-label={`Show image ${index + 1}`}
            className={`thumbnail${index === currentIndex ? ' active' : ''}`}
            key={`${image}-${index}`}
            onClick={() => showImage(index)}
            type="button"
          >
            <img src={image} alt="" style={{ opacity: index === currentIndex ? 1 : 0.6 }} />
          </button>
        ))}
      </div>
    </div>
  );
}
